import { Team } from '@/types/cricket';

export const getInningsDisplay = (inningsNumber: number): string => {
  const suffixes = ['', 'st', 'nd', 'rd'];
  const suffix = suffixes[inningsNumber] || 'th';
  return `${inningsNumber}${suffix}`;
};

export const getTeamName = (teamId: string, teams: Team[]): string => {
  return teams.find(t => t.id === teamId)?.name || 'Unknown Team';
};

export const formatOverNumber = (overNumber: number): string => {
  return (overNumber + 1).toString().padStart(2, '0');
};

export const formatBallDisplay = (overNumber: number, ballNumber: number, ballsPerOver: number): string => {
  if (ballNumber === ballsPerOver - 1) {
    return `${overNumber + 1}.0`; // End of over, e.g., 1.0, 2.0
  } else {
    return `${overNumber}.${ballNumber + 1}`; // Regular ball, e.g., 0.1, 0.2
  }
};

export const getBallButtonClass = (
  isExtraBall: boolean,
  isFreeHit: boolean
): string => {
  return `w-12 h-12 p-0 text-gray-800 hover:opacity-80 ${
    isExtraBall ? 'border-2 border-dashed' : ''
  } ${isFreeHit ? 'border-2 border-orange-500' : ''}`;
}; 